import { useState, useEffect } from 'react';

const useTableHeight = (headerHeight = 330, headerHeight2 = 200, footerHeight = 5) => {
  const [tableHeight, setTableHeight] = useState(20);
  const [tableHeight2, setTableHeight2] = useState(20);

  useEffect(() => {
    const calculateHeight = () => {
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      const availableHeight2 = window.innerHeight - headerHeight2 - footerHeight;
      setTableHeight(availableHeight);
      setTableHeight2(availableHeight2);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);

    return () => window.removeEventListener('resize', calculateHeight);
  }, [headerHeight, headerHeight2, footerHeight]);

  return { tableHeight, tableHeight2 };
};

export default useTableHeight;
